import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Settings.svg?component
var Settings_exports = /* @__PURE__ */ __exportAll({
	default: () => Settings_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M20 7H9m0 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 10H5m11 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
	}, null, -1)])]);
}
var Settings_default = { render: render$1 };
//#endregion
export { Settings_exports, Settings_default as default, render$1 as render };

//# sourceMappingURL=Settings.svg.virtual.js.map